import React, { useCallback, useEffect, useState } from "react";
import SearchForm from "./SearchForm/SearchForm";
import SearchResults from "./SearchResults/SearchResults";
import SearchTags from "./SearchTags/SearchTags";
import bodyLocker from "../../../jquery/bodyLocker";

const Search = ({ popularTags }) => {
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [results, setResults] = useState(null);

    const escFunction = useCallback((event) => {
        if (event.key === "Escape") {
            setIsPopupOpen(false);
        }
    }, []);

    useEffect(() => {
        document.addEventListener("keydown", escFunction, false);

        return () => {
            document.removeEventListener("keydown", escFunction, false);
        };
    }, [escFunction]);

    useEffect(() => {
        window.setSearchIsOpenState = (value) => {
            setIsPopupOpen(value);
        };
    }, []);

    useEffect(() => {
        if (isPopupOpen) {
            bodyLocker.lock();
        } else {
            bodyLocker.unlock();
        }

        if (window.fullpage_api) {
            window.fullpage_api.setAllowScrolling(!isPopupOpen);
        }
    }, [isPopupOpen]);

    // console.log("Search: Render!");

    return (
        <aside
            className={["search", isPopupOpen ? "search--open" : ""].join(" ")}
        >
            <div
                className="search__bg-layer"
                onClick={() => {
                    setIsPopupOpen(false);
                }}
            ></div>
            <div className="search__body">
                <div className="search__window">
                    <SearchForm
                        setResults={setResults}
                        isPopupOpen={isPopupOpen}
                    />

                    <div className="search__results">
                        {results ? <SearchResults results={results} /> : null}
                    </div>

                    {results?.tags.length ? (
                        <SearchTags title="Теги" tags={results.tags} />
                    ) : null}

                    {results === null ? (
                        <SearchTags
                            title="Популярные теги"
                            tags={popularTags}
                        />
                    ) : null}
                </div>
                <button
                    className="search__btn-close"
                    onClick={() => {
                        setIsPopupOpen(false);
                    }}
                >
                    <svg className="icon">
                        <use xlinkHref="/images/sprite.svg#close"></use>
                    </svg>
                </button>
            </div>
        </aside>
    );
};

export default Search;
